import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    sx: {
      boxSize: '4',
    },
  },
  iconButtonScrollRight: {
    fontSize: 'sm',
    p: '1',
    border: 'none',
    textShadow: '0px 1px 1px rgba(255, 255, 255, 0.50)',
    color: 'white',
    bgGradient: 'linear(to-b, beta.500, beta.500)',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: '0px 3px 3px 0px',
    minW: 4,
    maxW: 4,
    h: '29px',
    _hover: {
      color: 'alpha.600',
    },
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    sx: {
      boxSize: '4',
    },
  },
  iconButtonScrollLeft: {
    fontSize: 'sm',
    p: '1',
    border: 'none',
    textShadow: '0px 1px 1px rgba(255, 255, 255, 0.50)',
    color: 'white',
    bgGradient: 'linear(to-b, beta.500, beta.500)',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: '3px 0px 0px 3px',
    minW: 4,
    maxW: 4,
    h: '29px',
    _hover: {
      color: 'alpha.600',
    },
  },
  flexWrapper: {
    bg: 'blackAlpha.600',
    borderRadius: 'md',
    boxShadow: '0 1px rgba(255, 255, 255, .05)',
  },
  buttonGroupSports: {
    display: 'inline-flex',
    flex: '1',
    bg: 'alpha.600',
    overflowX: 'auto',
    p: '1',
    mr: [null, null, 2],
    spacing: '1',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    whiteSpace: 'nowrap',
    pos: 'relative',
    w: ['120px', 'auto', null],
    borderRadius: [null, null, 'md'],
    inset: 0,
    right: [null, null, null, '38px'],
    sx: {
      '::-webkit-scrollbar': { display: 'none' },
      button: {
        '-webkit-tap-highlight-color': 'transparent',
      },
    },
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    pr: '2px',
    pos: 'relative',
    borderRadius: 'md',
    spacing: '1',
    ml: 'auto',
    gap: 0.5,
    isAttached: true,
  },
  scrollIndicator: {
    w: 2,
    h: '0.5',
    bg: 'gamma.200',
    pos: 'absolute',
    bottom: 'px',
    transition: 'all 0.2s ease',
  },
};
